import React, { useEffect, useState } from "react";
import { useSwiper } from "swiper/react";

const SwiperNavButtons = ({ swipeLength }) => {
  const swiper = useSwiper();
  const [overFlow, setOverFlow] = useState(false);
  const [preFlow, setPreFlow] = useState(true);

  useEffect(() => {
    swiper.on("slideChange", () => {
      // console.log(swiper.activeIndex);
      setPreFlow(swiper.activeIndex === 0);
      setOverFlow(swiper.activeIndex > swipeLength);
    });
  }, [swiper, swipeLength]);

  return (
    <div className="swiper-nav-buttons">
      <div
        onClick={(e) => {
          e.preventDefault();

          swiper.slidePrev();
          setPreFlow(swiper.activeIndex === 0);
        }}
        className={`swBtnLeft ${preFlow ? "dnone" : ""}`}
      >
        &lt;
      </div>
      <div
        onClick={(e) => {
          e.preventDefault();
          swiper.slideNext();
        }}
        className={`swBtnRight ${overFlow ? "dnone" : ""}`}
      >
        &gt;
      </div>
      <div className={`whiteSpread ${overFlow ? "onone" : ""}`}></div>
    </div>
  );
};

export default SwiperNavButtons;
